import { last } from 'lodash';

import { Foreclosure } from '@willow/graphql-iso/src/app';

export const getActiveForeclosure = (foreclosures?: Foreclosure[] | null): Foreclosure | undefined => {
  return foreclosures != null ? last(foreclosures.filter((fc) => fc.endDate == null)) : undefined;
};
